'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('../../transport/transport.js');

class ResponsibleGaming {
  getTimeoutCategories() {
    return transport.transport.request("responsiblegaming/getTimeoutCategories");
  }
  getTimeoutDurations() {
    return transport.transport.request("responsiblegaming/getTimeoutDurations");
  }
  getSelfExclusionPeriods() {
    return transport.transport.request("responsiblegaming/getSelfExclusionPeriodsV2");
  }
  enableSelfExclusion(params) {
    return transport.transport.request("responsiblegaming/enableSelfExclusionV2", params);
  }
  getSelfExclusionURL() {
    return transport.transport.request("responsiblegaming/getSelfExclusionURL");
  }
  enableSelfExclusionCoolOff(params) {
    return transport.transport.request("responsiblegaming/enableSelfExclusionCoolOff", params);
  }
  enableLotbaPanicSelfExclusion() {
    return transport.transport.request("responsibleGaming/AddPanicSelfExclusion");
  }
  setUserLimits(params) {
    return transport.transport.request("responsiblegaming/setUserLimitsV2", params);
  }
  getUserLimits(params) {
    return transport.transport.request("responsiblegaming/getUserLimitsV2", params);
  }
  removeLimit(params) {
    return transport.transport.request("responsiblegaming/RemoveLimit", params);
  }
  getUserPlayStatsAndLimits(params) {
    return transport.transport.request("responsiblegaming/userPlayStatsAndLimits", params);
  }
  getLimits() {
    return transport.transport.request("responsiblegaming/getLimitsV2");
  }
  awaitingUserLimitConfirmation() {
    return transport.transport.request("responsiblegaming/awaitingUserLimitConfirmation");
  }
  confirmUserLimits(payload) {
    return transport.transport.request("responsiblegaming/confirmUserLimits", payload);
  }
}

exports.ResponsibleGaming = ResponsibleGaming;
